import React from "react";
import ReactTooltip from "react-tooltip";
import { DonorPerfectImportFilterMode } from "../../../../types/services/DonorPerfectTypes";
import SegmentedToggle from "../common/segmentedToggle";
import { formatImportFilterModeTooltip } from "./utils";

export interface ImportFilterSettingsStepProps {
  importFilterMode: DonorPerfectImportFilterMode;
  setImportFilterMode: (value: DonorPerfectImportFilterMode) => void;
}

const ImportFilterSettingsStep = ({
  importFilterMode,
  setImportFilterMode,
}: ImportFilterSettingsStepProps) => (
  <div>
    <p>
      Choose how selected donor types and segment flags combine when importing
      donors from DonorPerfect.
    </p>
    <SegmentedToggle
      title="Import filter"
      value={importFilterMode}
      options={[
        { value: "intersection", label: "AND" },
        { value: "union", label: "OR" },
      ]}
      onChange={value =>
        setImportFilterMode(value as DonorPerfectImportFilterMode)
      }
      showInfo={true}
      infoId="ImportFilterSettings"
    />
    <ReactTooltip
      id="tpImportFilterSettings"
      type="info"
      place="bottom"
      effect="float"
    >
      {formatImportFilterModeTooltip(importFilterMode)}
    </ReactTooltip>
  </div>
);

export default ImportFilterSettingsStep;
